import type { Theme } from '../../themes/themes';

export const createCheckboxTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: '6px',
          whiteSpace: 'pre',
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          marginRight: theme.spacing(4),
          padding: 0,

          '&.Mui-checked': {
            color: theme.palette.search.checkbox['iconSelected'],
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
          variants: [{ props: { color: 'error' }, style: { color: theme.palette.error.main } }],
        },
      },
    },
  },
});
